import { listenForChildMessage, postToOpener } from 'components/CallScribe/popupChannel';

const CALL_STATE_MESSAGE = 'mspp.callscribe.callState';

export type TCallPhase = 'started' | 'ended';

let sequence = 0;

export const emitCallStateSignal = (
  phase: TCallPhase,
  callId: number | undefined,
): void => {
  sequence += 1;
  postToOpener({
    type: CALL_STATE_MESSAGE,
    phase,
    callId: callId ?? null,
    seq: sequence,
  });
};

export const emitCallEndSignal = (callId: number | undefined): void => {
  emitCallStateSignal('ended', callId);
};

export const subscribeToCallStateSignal = (onSignal: () => void): (() => void) =>
  listenForChildMessage(CALL_STATE_MESSAGE, () => { onSignal(); });
